import { GanttTask } from '../../types/gantt.types'
import { Button, Textarea } from '@indipia/ui-core'
// 하단 비고 카드

export type GanttRemarkBarProps = {
  loading: boolean
  tasks: GanttTask[]
  remarkHidden: boolean
  remarkDraft: string
  setRemarkHidden: React.Dispatch<React.SetStateAction<boolean>>
  setRemarkDraft: React.Dispatch<React.SetStateAction<string>>
  scheduleRemark: string
  remarkSaving: boolean
  handleRemarkSave: () => Promise<void>
}

export function GanttRemarkBar({
  loading, tasks, remarkHidden, remarkDraft, setRemarkHidden, setRemarkDraft, scheduleRemark, remarkSaving,
  handleRemarkSave,
}: GanttRemarkBarProps) {
  return (
    <>
      {!loading && tasks.length > 0 && (
        <div style={{ background: 'var(--shell-bg)', borderTop: 'var(--border-width-hairline) solid var(--shell-border)', padding: '10px 16px 12px', flexShrink: 0 }}>
          <div style={{ background: 'var(--shell-surface)', border: 'var(--border-width-hairline) solid var(--shell-border)', borderRadius: 12, overflow: 'hidden', boxShadow: 'var(--elevation-1)' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '8px 12px', borderBottom: 'var(--border-width-hairline) solid var(--shell-border)', background: 'var(--shell-bg)' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 7 }}>
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="var(--gt-primary)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
                <span style={{ fontSize: 12, fontWeight: 700, color: 'var(--shell-on-surface)' }}>비고</span>
                <span style={{ fontSize: 'var(--type-caption-size)', color: 'var(--shell-on-surface-2)' }}>현장 전체 일정에 대한 기록입니다.</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                {!remarkHidden && <span style={{ fontSize: 'var(--type-caption-size)', color: 'var(--shell-on-surface-2)' }}>{remarkDraft.length} / 500</span>}
                <Button
                  variant="ghost"
                  size="sm"
                  className="gap-1"
                  onMouseDown={e => e.stopPropagation()}
                  onClick={() => setRemarkHidden(h => !h)}
                >
                  {remarkHidden ? (
                    <><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>펼치기</>
                  ) : (
                    <><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></svg>숨기기</>
                  )}
                </Button>
              </div>
            </div>
            {!remarkHidden && (
              <div style={{ display: 'flex', alignItems: 'flex-end', gap: 10, padding: '10px 12px' }}>
                <Textarea
                  value={remarkDraft}
                  maxLength={500}
                  onChange={e => setRemarkDraft(e.target.value)}
                  onMouseDown={e => e.stopPropagation()}
                  placeholder="예) 6/18 오전 엘리베이터 사용 불가, 자재 반입은 오후 2시 이후 가능"
                  className="!max-w-none flex-1"
                  style={{ minHeight: 54, maxHeight: 96 }}
                />
                <Button
                  variant="primary"
                  size="sm"
                  className="whitespace-nowrap"
                  onMouseDown={e => e.stopPropagation()}
                  disabled={remarkDraft === scheduleRemark}
                  loading={remarkSaving}
                  onClick={handleRemarkSave}
                >{remarkSaving ? '저장 중...' : '비고 저장'}</Button>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  )
}
